// extracted by mini-css-extract-plugin
module.exports =  {"container":"PaneActions-module__container--tx2hF"};